<template>
  <section class="h-auto hero-bg">
    <div class="max-w-[1200px] mx-auto px-4 lg:px-8">
      <div class="flex flex-col items-right pt-28 md:pt-36 lg:pt-40 font-oxanium">
        <!-- Profile Card -->
        <MilestoneProfileCard />

        <!-- Accounts Section -->
        <div
          class="bg-[#2d3546] rounded-2xl p-6 mb-8"
          style="background: linear-gradient(90.59deg, #1d1d1d 0%, #313b44 100%)"
        >
          <div class="flex justify-between items-center mb-6">
            <h2 class="text-xl font-bold text-white font-montserrat">Accounts</h2>
            <!-- Edit Button -->
            <button
              v-if="isEdit == false && loading == false"
              @click="isEdit = true"
              class="text-white hover:text-gray-300"
            >
              <!-- Edit Icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                viewBox="0 0 24 24"
              >
                <path d="M12 20h9"></path>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
              </svg>
            </button>

            <!-- Save Button -->
            <div v-if="isEdit == true && loading == false" class="flex flex-row gap-2">
              <button @click="saveProfile()" class="text-green-500 hover:text-green-300">
                <!-- Save Icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                  />
                  <polyline points="17 21 17 13 7 13 7 21" />
                  <polyline points="7 3 7 8 15 8" />
                </svg>
              </button>
              <button @click="isEdit = false" class="hover:cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="red"
                  class="w-[30px]"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <div v-if="loading == true" role="status">
              <svg
                aria-hidden="true"
                class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div class="space-y-6">
            <!-- Metaspins Section -->
            <div class="space-y-4">
              <div class="flex items-center gap-3">
                <div class="rounded-md flex items-center justify-center">
                  <img :src="accounts[1].logo" class="50 h-12" alt="Metaspins" />
                </div>
                <!-- <h3 class="font-medium text-white font-montserrat">Metaspins</h3> -->
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="space-y-1">
                  <p class="text-sm text-gray-400">
                    Player ID <span class="text-red-500">*</span>
                  </p>
                  <div class="flex">
                    <input
                      v-model="accountsData.metaspinsPlayerId"
                      type="text"
                      class="flex-1 bg-gray-700 rounded-md px-3 py-2 text-sm text-white"
                      :disabled="isEdit == false"
                      :class="isEdit == false ? 'bg-transparent' : 'bg-[#666666]'"
                      placeholder="Enter Player ID"
                    />
                    <!-- <button @click="saveAccount('metaspinsPlayerId')" class="ml-2 px-3 py-1 text-sm text-white hover:bg-gray-700 rounded-md">
                                            Save
                                        </button> -->
                  </div>
                </div>

                <div class="space-y-1">
                  <p class="text-sm text-gray-400">Display Name</p>
                  <div class="flex">
                    <input
                      v-model="accountsData.metaspinsDisplayName"
                      type="text"
                      class="flex-1 bg-gray-700 rounded-md px-3 py-2 text-sm text-white"
                      :disabled="isEdit == false"
                      :class="isEdit == false ? 'bg-transparent' : 'bg-[#666666]'"
                      placeholder="Enter Display Name"
                    />
                    <!-- <button @click="saveAccount('metaspinsDisplayName')" class="ml-2 px-3 py-1 text-sm text-white hover:bg-gray-700 rounded-md">
                                            Save
                                        </button> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- Dailyspins Section -->
            <div class="space-y-4">
              <div class="flex items-center gap-3">
                <div class="rounded-md flex items-center justify-center">
                  <img :src="accounts[0].logo" class="50 h-12" alt="Dailyspins" />
                </div>
                <!-- <h3 class="font-medium text-white font-montserrat">Dailyspins</h3> -->
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="space-y-1">
                  <p class="text-sm text-gray-400">
                    Player ID <span class="text-red-500">*</span>
                  </p>
                  <div class="flex">
                    <input
                      v-model="accountsData.dailyspinsPlayerId"
                      type="text"
                      class="flex-1 bg-gray-700 rounded-md px-3 py-2 text-sm text-white"
                      :disabled="isEdit == false"
                      :class="isEdit == false ? 'bg-transparent' : 'bg-[#666666]'"
                      placeholder="Enter Player ID"
                    />
                    <!-- <button @click="saveAccount('dailyspinsPlayerId')" class="ml-2 px-3 py-1 text-sm text-white hover:bg-gray-700 rounded-md">
                                            Save
                                        </button> -->
                  </div>
                </div>

                <div class="space-y-1">
                  <p class="text-sm text-gray-400">Display Name</p>
                  <div class="flex">
                    <input
                      v-model="accountsData.dailyspinsUsername"
                      type="text"
                      class="flex-1 bg-gray-700 rounded-md px-3 py-2 text-sm text-white"
                      :disabled="isEdit == false"
                      :class="isEdit == false ? 'bg-transparent' : 'bg-[#666666]'"
                      placeholder="Enter Display Name"
                    />
                    <!-- <button @click="saveAccount('dailyspinsDisplayName')" class="ml-2 px-3 py-1 text-sm text-white hover:bg-gray-700 rounded-md">
                                        Save
                                        </button> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- Empire Drop Section -->
            <div class="space-y-4">
              <div class="flex items-center gap-3">
                <div class="rounded-md flex items-center justify-center">
                  <img :src="accounts[2].logo" class="w-50 h-12" alt="Empire Drop" />
                </div>
                <!-- <h3 class="font-medium text-white font-montserrat">Empire Drop</h3> -->
              </div>

              <div class="space-y-1">
                <p class="text-sm text-gray-400">User ID</p>
                <div class="flex">
                  <input
                    v-model="accountsData.empireDropUserId"
                    type="text"
                    class="flex-1 bg-gray-700 rounded-md px-3 py-2 text-sm text-white"
                    :disabled="isEdit == false"
                    :class="isEdit == false ? 'bg-transparent' : 'bg-[#666666]'"
                    placeholder="Enter User ID"
                  />
                  <!-- <button @click="saveAccount('empireDropUserId')" class="ml-2 px-3 py-1 text-sm text-white hover:bg-gray-700 rounded-md">
                                        Save
                                    </button> -->
                </div>
              </div>
            </div>

            <!-- Kick Section -->
            <div class="space-y-4">
              <div class="flex items-center gap-3">
                <div class="rounded-md flex items-center justify-center">
                  <img :src="accounts[4].logo" class="w-50 h-8" alt="Kick" />
                </div>
              </div>

              <div class="space-y-1">
                <div class="flex">
                  <input
                    v-model="accountsData.kick"
                    type="text"
                    class="flex-1 bg-gray-700 rounded-md px-3 py-2 text-sm text-white"
                    :disabled="isEdit == false"
                    :class="isEdit == false ? 'bg-transparent' : 'bg-[#666666]'"
                    placeholder="Enter Kick username"
                  />
                  <!-- <button @click="saveAccount('kick')" class="ml-2 px-3 py-1 text-sm text-white hover:bg-gray-700 rounded-md">
                                        Save
                                    </button> -->
                </div>
              </div>
            </div>

            <!-- Twitter/X Section -->
            <div class="space-y-4">
              <div class="flex items-center gap-3">
                <div class="rounded-md flex items-center justify-center">
                  <img :src="accounts[3].logo" class="w-50 h-12" alt="twitter" />
                </div>
                <!-- <h3 class="font-medium text-white font-montserrat">Twitter/X</h3> -->
              </div>

              <div class="space-y-1">
                <div class="flex">
                  <input
                    v-model="accountsData.twitterX"
                    type="text"
                    class="flex-1 bg-gray-700 rounded-md px-3 py-2 text-sm text-white"
                    :disabled="isEdit == false"
                    :class="isEdit == false ? 'bg-transparent' : 'bg-[#666666]'"
                    placeholder="Enter Twitter/X username"
                  />
                  <!-- <button @click="saveAccount('twitterX')" class="ml-2 px-3 py-1 text-sm text-white hover:bg-gray-700 rounded-md">
                                    Save
                                </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Disclaimer Section -->
        <div
          class="bg-[#2d3546] rounded-2xl p-6 mb-8"
          style="background: linear-gradient(90.59deg, #1d1d1d 0%, #313b44 100%)"
        >
          <h2 class="text-xl font-bold mb-4 text-white font-montserrat">Disclaimer</h2>
          <ol class="space-y-2 list-decimal list-inside text-gray-300">
            <li>
              Users must put the correct information to avoid discrepancies in points or
              else points won't be distributed correctly
            </li>
            <li>
              Any loss of points, the bally boy team will not be held liable due to
              incorrect information entered on profile page
            </li>
          </ol>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import store from "@/store";
import { defineComponent } from "vue";
import MilestoneProfileCard from "../components/MilestoneProfileCard.vue";

export default defineComponent({
  components: {
    MilestoneProfileCard,
  },
  data() {
    return {
      userToken: null,

      isEdit: false,
      loading: false,
      displayName: null,
      email: null,
      picUrl: null,
      discordID: null,

      accounts: [
        {
          title: "DAILYSPINS",
          logo: require("@/assets/promo-dailyspins.png"),
        },
        {
          title: "Metaspins",
          logo: require("@/assets/promo-metaspins.png"),
        },
        {
          title: "Empiredrop",
          logo: require("@/assets/promo-empiredrop.png"),
        },
        {
          title: "Twitter",
          logo: require("@/assets/twitter.png"),
        },
        {
          title: "Kick",
          logo: require("@/assets/kick-logo-transparent.png"),
        },
      ],

      accountsData: {
        metaspinsPlayerId: "",
        metaspinsDisplayName: "",
        dailyspinsPlayerId: "",
        dailyspinsUsername: "",
        empireDropUserId: "",
        twitterX: "",
        kick: "",
      },

      milestonesArray: [
        { reward: "50", wager: "10,000" },
        { reward: "250", wager: "100,000" },
        { reward: "1000", wager: "500,000" },
        { reward: "2,500", wager: "1,500,000" },
        { reward: "5,000", wager: "4,000,000" },
      ],
    };
  },
  methods: {
    init() {
      this.userToken =
        store.state.user?.accessToken || localStorage.getItem("ballyboy-access-token");

      if (this.userToken) {
        axios
          .get(process.env.VUE_APP_BASE_API + "/api/user", {
            headers: {
              "x-api-key": process.env.VUE_APP_X_API_KEY,
              Authorization: `Bearer ${this.userToken}`,
            },
          })
          .then((res) => {
            if (res.data) {
              this.displayName = res.data.user.username;
              this.email = res.data.user.email;
              this.picUrl =
                "https://cdn.discordapp.com/avatars/" +
                res.data.user.discordId +
                "/" +
                res.data.user.profileImage +
                ".png";
              this.discordID = res.data.user.discordId;

              this.accountsData.metaspinsPlayerId = res.data.user.metaspins;
              this.accountsData.metaspinsDisplayName = res.data.user.metaspinsUsername;
              this.accountsData.dailyspinsPlayerId = res.data.user.dailyspinsPlayerId;
              this.accountsData.dailyspinsUsername = res.data.user.dailyspinsUsername;

              this.accountsData.empireDropUserId = res.data.user.empireDropUserId;
              this.accountsData.twitterX = res.data.user.twitter;

              this.accountsData.kick = res.data.user.kick;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 401) {
                localStorage.removeItem("vuex");
                localStorage.removeItem("ballyboy-access-token");
                window.location.reload();
              } else {
                console.log(`Error: ${error.response.status}`);
              }
            } else if (error.request) {
              console.log("No response received", error.request);
            } else {
              console.log("Error", error.message);
            }
          });
      }
    },
    isMobile() {
      return window.innerWidth < 1024;
    },
    saveProfile() {
      this.loading = true;
      const token = localStorage.getItem("ballyboy-access-token");
      const formData = {
        metaspins: this.accountsData.metaspinsPlayerId,
        metaspinsUsername: this.accountsData.metaspinsDisplayName,
        empireDropUserId: this.accountsData.empireDropUserId,
        dailyspinsPlayerId: this.accountsData.dailyspinsPlayerId,
        dailyspinsUsername: this.accountsData.dailyspinsUsername,
        twitter: this.accountsData.twitterX,
        kick: this.accountsData.kick,
      };
      axios
        .put(process.env.VUE_APP_BASE_API + "/api/user/update", formData, {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.data) {
            this.init();
            this.loading = false;
            this.isEdit = false;
          }
        });
    },
  },
  mounted() {
    this.init();
  },
});
</script>

<style scoped>
.hero-bg {
  background-image: url("../assets/hero-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
}
.hero-bg-mobile {
  background-image: url("../assets/hero-bg-mobile.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.cards-frame {
  background-image: url("../assets/cards-frame.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.milestone-card-bg {
  background: rgb(252, 252, 252);
  background: -moz-linear-gradient(
    148deg,
    rgba(252, 252, 252, 0.1) 0%,
    rgba(18, 148, 240, 0.1) 100%
  );
  background: -webkit-linear-gradient(
    148deg,
    rgba(252, 252, 252, 0.1) 0%,
    rgba(18, 148, 240, 0.1) 100%
  );
  background: linear-gradient(
    148deg,
    rgba(252, 252, 252, 0.1) 0%,
    rgba(18, 148, 240, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fcfcfc",endColorstr="#1294f0",GradientType=1);
  padding: 1px;
}
</style>
